import { Step, StepContent, StepLabel, Typography } from "@mui/material";
import { useLocaleState } from "react-admin";

import AssignmentIcon from "@mui/icons-material/Assignment";
import LabelField from "../../unit/LabelField";
import { useEffect, useState } from "react";

const NewApplicationInfo = ({ ...props }) => {
  const data = props.record;
  const [locale] = useLocaleState();
  const [record, setRecord] = useState<{
    termSubmit: any;
    amountSubmit: any;
    counselorVerifyStatus: any;
    counselorVerifyAt: any;
    dtInsert: any;
    total: number;
    filelist?: { id: number; filename: string }[];
    employerVerifyStatus?: any;
    employerVerifyAt?: string;
  } | null>(null);
  useEffect(() => {
    setRecord(data);
  }, [data]);

  if (!record) {
    return <Typography>Loading New Application Log Data</Typography>;
  }

  function getEmployerVerified() {
    if (
      record?.attrs?.first_employer_verified != "" &&
      record?.attrs?.first_employer_verified != null
    ) {
      if (record?.attrs?.first_employer_verified == "Verified") {
        return record.attrs?.first_employer_verified_at || "";
      } else {
        return record?.attrs?.first_employer_verified;
      }
    } else {
      if (
        record?.employerVerifyAt &&
        record?.employerVerifyStatus == "Verified"
      ) {
        return record.employerVerifyAt;
      } else {
        return record?.employerVerifyStatus;
      }
    }
  }
  function getCounselorVerified() {
    //  record?.counselorVerifyAt &&
    //           record?.counselorVerifyStatus == "Verified"
    //             ? record.counselorVerifyAt
    //             : record?.counselorVerifyStatus
    if (
      record?.attrs?.first_counselor_verified != "" &&
      record?.attrs?.first_counselor_verified != null
    ) {
      if (record?.attrs?.first_counselor_verified == "Verified") {
        return record.attrs?.first_counselor_verified_at || "";
      } else {
        return record?.attrs?.first_counselor_verified;
      }
    } else {
      if (
        record?.counselorVerifyAt &&
        record?.counselorVerifyStatus == "Verified"
      ) {
        return record.counselorVerifyAt;
      } else {
        return record?.counselorVerifyStatus;
      }
    }
  }
  return (
    record && (
      <Step key="Application New" expanded active completed>
        <StepLabel icon={<AssignmentIcon />}>New Application</StepLabel>
        <StepContent>
          <LabelField
            title="Date Received"
            value={record?.dtDocusignComplete}
            format="date"
            fontFamily="numberFontFamily"
            prefix="EST"
          />
          {/* <LabelField
            title="Employer Verified"
            value={
              record?.employerVerifyAt &&
              record?.employerVerifyStatus == "Verified"
                ? record.employerVerifyAt
                : record?.employerVerifyStatus
            }
            fontFamily="numberFontFamily"
          /> */}
          <LabelField
            title="Employer Verified"
            value={getEmployerVerified()}
            fontFamily="numberFontFamily"
          />
          {/* <LabelField
            title="Counselor Verified"
            value={
              record?.counselorVerifyAt &&
              record?.counselorVerifyStatus == "Verified"
                ? record.counselorVerifyAt
                : record?.counselorVerifyStatus
            }
            fontFamily="numberFontFamily"
          /> */}
          <LabelField
            title="Counselor Verified"
            value={getCounselorVerified()}
            fontFamily="numberFontFamily"
          />
          <LabelField
            title="Amount Applied"
            value={record?.amountSubmit}
            format="amount"
            fontFamily="numberFontFamily"
          />
          <LabelField
            title="Term Applied"
            value={record?.termSubmit + " Month(s)"}
            format="string"
            fontFamily="numberFontFamily"
          />
        </StepContent>
      </Step>
    )
  );
};

{
  /* <LabelAttachedField list={record.filelist} appId={record.id} />
   */
}
{
  /* <ApplicationFilesLabel appId={record.id} step='New Application' substep='All' /> */
}
export default NewApplicationInfo;
